export default "__VITE_ASSET__rXVMnIx1__"